import "core-js/features/url-search-params";
import { DateRegexConfig, consentMapping } from "./config";
export const getUrlParamByName = (queryString, name) => {
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(name);
};

export const isUrlParamByName = (queryString, name) => {
  const urlParams = new URLSearchParams(queryString);
  return urlParams.has(name);
};

export const checkDobError = (dob, format) => {
  console.log(dob, format);
  if (dob.length === 0) {
    return { message: "this field is required" };
  }
  const birthDate =
    format === "MM/DD/YYYY" ? dob : `${dob.slice(0, 3)}01/${dob.slice(3)}`;
  console.log(DateRegexConfig[format].test(dob));
  if (
    DateRegexConfig[format].test(dob) &&
    new Date(birthDate).getTime() &&
    new Date().getTime() - new Date(birthDate).getTime() > 0
  ) {
    return null;
  } else {
    return { message: "Please enter a valid date of birth" };
  }
};

export const dobISOTransform = (format, dob) => {
  if (format === "MM/YYYY") {
    return `${dob.slice(3)}-${dob.slice(0, 2)}-00`;
  } else {
    return `${dob.slice(6)}-${dob.slice(0, 2)}-${dob.slice(3, 5)}`;
  }
};

export const parseConsent = (consents) => {
  const parsedConsent = {};
  const serviceTypeRegex = /\w+(?=\/v)/;
  const versionRegex = /\d-\d/;
  let serviceType, version;

  // the backend happens to send consents not sort them
  // this is sorting the consent array by timestamp
  consents.sort(
    (memo, item) => new Date(memo.timestamp) - new Date(item.timestamp)
  );
  for (const consent of consents) {
    try {
      serviceType = consent.consentAsked.match(serviceTypeRegex)[0];
      version = consent.consentAsked.match(versionRegex)[0];

      parsedConsent[`${consentMapping[serviceType]}Consent`] = {
        version,
        trackTechnicalData: { value: false },
        trackTechnicalData: { value: false },
        consentAsked: consent.consentAsked,
      };

      //consentGranted comes as an array from starfleet
      for (const consentPair of consent.consentGranted) {
        const [key, value] = consentPair.split(":");
        console.log(key, value);

        if (key !== "opt_in")
          parsedConsent[`${consentMapping[serviceType]}Consent`][key] = {
            value: value === "true",
          };
      }
    } catch (err) {
      console.log("consentAsked URL is not matching the spec", err);
    }
  }

  return parsedConsent;
};

export const getVoltronBase = () => {
  if (isCNTLD()) {
    return VOLTRON_BASE_CN;
  }
  return VOLTRON_BASE;
};

export const getStarfleetBase = () => {
  if (isCNTLD()) {
    return STARFLEET_BASE_CN;
  }
  return STARFLEET_BASE;
};

export const isCNTLD = () => {
  return location.host.includes(".cn");
};

export const isCOMTLD = () => {
  return location.host.includes(".com");
};
